export default __webpack_public_path__ + "static/media/img7.8f722b95.jpg";